import qrcode from 'qrcode-generator';

const QUIET_ZONE = 4; // модуля — стандартная тихая зона, без неё часть сканеров не читает код

function matrix(text: string) {
    const qr = qrcode(0, 'M');
    qr.addData(text);
    qr.make();
    const n = qr.getModuleCount();
    const cells: [number, number][] = [];
    for (let r = 0; r < n; r++) for (let c = 0; c < n; c++) if (qr.isDark(r, c)) cells.push([r, c]);
    return { n, cells };
}

/** Тёмные модули на белом — только так QR читают сканеры Telegram и ML Kit (см. CLAUDE.md про инвертированный QR). */
export function QrCode({ value, size = 220 }: { value: string; size?: number }) {
    const { n, cells } = matrix(value);
    const total = n + QUIET_ZONE * 2;
    return (
        <svg
            width={size}
            height={size}
            viewBox={`0 0 ${total} ${total}`}
            shapeRendering="crispEdges"
            style={{ borderRadius: 12, display: 'block' }}
            role="img"
            aria-label="QR-код"
        >
            <rect width={total} height={total} fill="#fff" />
            <path
                fill="#000"
                d={cells.map(([r, c]) => `M${c + QUIET_ZONE} ${r + QUIET_ZONE}h1v1h-1z`).join('')}
            />
        </svg>
    );
}

export function qrToPngBlob(value: string, sizePx = 1024): Promise<Blob> {
    const { n, cells } = matrix(value);
    const total = n + QUIET_ZONE * 2;
    const scale = Math.floor(sizePx / total);
    const canvas = document.createElement('canvas');
    canvas.width = canvas.height = total * scale;
    const ctx = canvas.getContext('2d')!;
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = '#000';
    for (const [r, c] of cells) ctx.fillRect((c + QUIET_ZONE) * scale, (r + QUIET_ZONE) * scale, scale, scale);
    return new Promise((resolve, reject) => canvas.toBlob((b) => (b ? resolve(b) : reject(new Error('PNG не собрался'))), 'image/png'));
}
